import accordion from "./archive-travel/accordion.js";
import Filters from "./archive-travel/filters.js";


import "../scss/pages/archive-travel.scss";




addEventListener("DOMContentLoaded", (event) => {
	accordion();
	Filters();
});
